module.exports = __webpack_public_path__ + "static/media/ana-lucena.f6ec131a.png";